import React from 'react'
import { BaseErrorDisplay } from './BaseErrorDisplay'
import infoSvg from '../icons/blankslate-info-icon.svg'

export const FederatedUserInvitationServerError = () => (
  <BaseErrorDisplay
    title="There is a problem processing your invitation"
    subtitle="FEDERATED USER INVITATION SERVER ERROR"
    description="An unexpected error occurred while processing the federated user invitation. Please contact your support."
    imgSrc={infoSvg}
  />
)
